{
  "name": "hypecast-admin-webapp",
  "version": "0.0.100",
  "private": true,
  "scripts": {
    "build": "ng build --configuration=${ANGULAR_ENVIRONMENT}",
    "postbuild": "node scripts/generate-version.mjs prod",
    "prestart": "node scripts/generate-version.mjs dev",
    "start": "ng serve --configuration=development",
    "lint": "ng lint",
    "lint:types": "tsc --noEmit -p tsconfig.app.json",
    "lint:styles": "stylelint \"src/**/*.scss\" --custom-syntax postcss-scss",
    "lint:html": "eslint \"src/**/*.html\"",
    "lint:full": "npm run lint && npm run lint:types && npm run lint:styles && npm run lint:html",
    "test": "vitest",
    "test:coverage": "vitest run --coverage",
    "test:ci": "npm run lint && npm run test:coverage",
    "e2e": "playwright test",
    "e2e:smoke": "playwright test --grep @smoke --project=chromium",
    "e2e:smoke:ci": "playwright test --grep @smoke --project=chromium --workers=1 --max-failures=1",
    "e2e:nightly": "playwright test --project=chromium --project=firefox --project=webkit --grep-invert @visual",
    "e2e:visual": "playwright test tests/e2e/visual-regression.spec.ts --project=chromium",
    "e2e:visual:update": "playwright test tests/e2e/visual-regression.spec.ts --project=chromium --update-snapshots",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:debug": "playwright test --debug",
    "e2e:report": "playwright show-report",
    "format:check": "prettier --check .",
    "ci:local": "act -j test --quiet",
    "ci:full": "act --quiet",
    "prepare": "husky",
    "postinstall": "patch-package"
  },
  "dependencies": {
    "@angular/animations": "22.2.1",
    "@angular/cdk": "^22.2.1",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/material": "^22.2.1",
    "@angular/platform-browser": "22.2.3",
    "@angular/router": "22.2.3",
    "@angular/service-worker": "22.2.3",
    "@datadog/browser-rum": "^7.9.0",
    "@datadog/browser-rum-angular": "^7.9.0",
    "@davidsystems/embedded-audio-object": "file:./vendor/davidsystems-embedded-audio-object-1.0.989.tgz",
    "@ffmpeg/core": "^0.12.10",
    "@ffmpeg/ffmpeg": "^0.12.15",
    "@ffmpeg/util": "^0.12.2",
    "@google/genai": "^1.10.0",
    "@microsoft/signalr": "^10.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@remotion/cli": "4.0.538",
    "@remotion/media": "4.0.538",
    "@remotion/player": "4.0.538",
    "@remotion/tailwind-v4": "4.0.538",
    "@remotion/zod-types": "4.0.538",
    "@stripe/stripe-js": "10.1.0",
    "@swimlane/ngx-charts": "^25.0.1",
    "@types/file-saver": "^2.0.5",
    "@types/jszip": "^3.4.0",
    "@types/quill": "^2.0.14",
    "angular-oauth2-oidc": "^22.0.2",
    "circular-json": "^0.5.9",
    "cors": "^2.8.5",
    "d3-geo": "^3.1.1",
    "dayjs": "^1.11.19",
    "express": "*",
    "file-saver": "^2.0.5",
    "hls.js": "^1.6.15",
    "howler": "^2.2.3",
    "idb-keyval": "^6.2.2",
    "jszip": "^3.10.1",
    "lucide-react": "^0.536.0",
    "material-icons": "^1.13.14",
    "ngx-image-cropper": "^9.1.6",
    "ngx-mask": "^22.1.0",
    "ngx-quill": "^31.0.1",
    "ngx-toastr": "^20.0.5",
    "pdfjs-dist": "5.4.54",
    "playwright": "^1.56.1",
    "quill": "^2.0.0",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "remotion": "4.0.538",
    "rxjs": "^7.5.6",
    "topojson-client": "^3.1.0",
    "world-atlas": "^2.0.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "22.2.4",
    "@angular/cli": "22.2.4",
    "@angular/compiler-cli": "22.2.3",
    "@datadog/browser-logs": "^7.9.0",
    "@datadog/datadog-ci": "^5.16.1",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.49.1",
    "@tailwindcss/postcss": "^4.2.1",
    "@testing-library/angular": "^17.3.7",
    "@testing-library/dom": "^10.4.1",
    "@types/d3-geo": "^3.1.0",
    "@types/howler": "^2.2.7",
    "@types/node": "^22.10.2",
    "@types/react": "^19.1.8",
    "@types/react-dom": "^19.1.6",
    "@types/topojson-client": "^3.1.5",
    "@typescript-eslint/eslint-plugin": "^8.68.0",
    "@typescript-eslint/parser": "^8.68.0",
    "@typescript-eslint/utils": "^8.68.0",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^22.1.0",
    "dotenv": "^17.2.4",
    "eslint": "^10.9.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-rxjs-x": "^1.0.6",
    "eslint-plugin-security": "^4.0.1",
    "husky": "^9.1.7",
    "jsdom": "^26.1.0",
    "lint-staged": "^17.3.0",
    "lit": "^2.4.0",
    "patch-package": "^8.0.1",
    "postcss": "^8.4.38",
    "postcss-scss": "^4.0.4",
    "prettier": "^3.8.1",
    "sass": "^1.86.3",
    "stylelint": "^14.9.1",
    "stylelint-config-recommended-scss": "^8.0.0",
    "tailwindcss": "^4.2.1",
    "ts-node": "^10.9.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.68.0",
    "vitest": "^4.1.11"
  },
  "overrides": {
    "zod": "^4.6.7"
  },
  "lint-staged": {
    "*.ts": [
      "eslint --fix"
    ],
    "*.html": [
      "prettier --write"
    ],
    "*.scss": [
      "prettier --write"
    ]
  }
}
